import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard, CanDeactivateGuard } from 'app/guards';
import { CbPaymentMethodComponent } from './cb-payment-method.component';
import { AddressInput } from '../../address-input/address-input.component';
import { NgxMaskModule } from 'ngx-mask';

const routes: Routes = [
  {
    path: 'payment-method',
    component: CbPaymentMethodComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  declarations: [CbPaymentMethodComponent, AddressInput],
  imports: [RouterModule.forChild(routes), TranslateModule, FuseSharedModule, NgxMaskModule],
  exports: [CbPaymentMethodComponent, AddressInput],
})
export class CbPaymentMethodModule { }
